// src/components/operationCenter/widgets/token/risk/TwSharpeSortinoWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import RollingSharpeSortinoTabs from "@/components/tokenPage/risk/RollingSharpeSortinoTabs";

const TwSharpeSortinoWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["price"]}>
        <RollingSharpeSortinoTabs />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwSharpeSortinoWidget;
